/** Compliance-approved — keep verbatim. */
export function Disclaimer() {
  return (
    <p className="text-body-xs text-neutral-darker">
      Results are for illustrative purposes only and do not constitute financial advice. Default assumptions: retirement
      at 60, life expectancy of 95, 8% pre-retirement return, 5% post-retirement return, 2% inflation, 3% annual salary
      increase. Does not account for taxes on withdrawals. NWWP is an SEC-registered investment adviser.
    </p>
  )
}
